<template>
  <el-dialog title="角色风格库" :visible.sync="visible" width="900px" :close-on-click-modal="false" append-to-body>
    <el-alert
      title="设置 AI 客户的行为特征、施压方式和让步条件，用于训练场景中的角色对话。"
      type="info"
      :closable="false"
      class="mb10"
    />
    <div class="mb10">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleCreate">新建角色风格</el-button>
    </div>
    <el-table v-loading="loading" :data="list" border size="small">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="roleType" label="角色类型" width="100">
        <template slot-scope="{row}">{{ roleTypeLabel(row.roleType) }}</template>
      </el-table-column>
      <el-table-column prop="name" label="名称" width="140" />
      <el-table-column prop="behavior" label="行为特征" show-overflow-tooltip />
      <el-table-column prop="pressure" label="施压方式" show-overflow-tooltip />
      <el-table-column prop="concession" label="让步条件" show-overflow-tooltip />
      <el-table-column label="状态" width="90">
        <template slot-scope="{row}">
          <el-tag :type="row.state === 1 ? 'success' : 'info'" size="mini">{{ row.state === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑角色风格' : '新建角色风格'" :visible.sync="formVisible" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="formRules" label-width="90px" size="small">
        <el-form-item label="角色类型" prop="roleType">
          <el-select v-model="form.roleType" placeholder="请选择" style="width:100%">
            <el-option :value="1" label="挑剔" />
            <el-option :value="2" label="友好" />
            <el-option :value="3" label="应付" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="行为特征">
          <el-input v-model="form.behavior" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="施压方式">
          <el-input v-model="form.pressure" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="让步条件">
          <el-input v-model="form.concession" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="角色对话指令" prop="promptTemplate">
          <el-input v-model="form.promptTemplate" type="textarea" :rows="4" placeholder="说明角色应如何回应学员、何时质疑以及何时接受建议" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>

    <div slot="footer">
      <el-button @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listRows } from '@/utils/ai-train-data'
import aiTrainRoleStyleApi from '@/api/aiTrain/roleStyle'

export default {
  name: 'AiTrainRoleStylePanel',
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      list: [],
      formVisible: false,
      form: this.emptyForm(),
      formRules: {
        roleType: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    emptyForm() {
      return { id: null, roleType: 1, name: '', behavior: '', pressure: '', concession: '', promptTemplate: '', state: 1 }
    },
    roleTypeLabel(v) {
      return { 1: '挑剔', 2: '友好', 3: '应付' }[v] || '-'
    },
    open() {
      this.visible = true
      this.loadList()
    },
    loadList() {
      this.loading = true
      aiTrainRoleStyleApi.fetchList({})
        .then(res => {
          const data = (res && res.data) || res || []
          this.list = listRows(data)
        })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    handleCreate() {
      this.form = this.emptyForm()
      this.formVisible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    handleEdit(row) {
      this.form = { ...this.emptyForm(), ...row }
      this.formVisible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.saving = true
        const api = this.form.id ? aiTrainRoleStyleApi.update(this.form) : aiTrainRoleStyleApi.create(this.form)
        api.then(() => {
          this.$message.success('保存成功')
          this.formVisible = false
          this.loadList()
          this.$emit('changed')
        }).catch(() => {}).finally(() => { this.saving = false })
      })
    },
    handleDelete(row) {
      this.$common.confirm('是否确认删除该角色风格？').then(() => aiTrainRoleStyleApi.deleteById(row.id))
        .then(() => {
          this.$message.success('删除成功')
          this.loadList()
          this.$emit('changed')
        })
    }
  }
}
</script>

<style scoped>
.mb10 { margin-bottom: 10px; }
</style>
